import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { AssessmentQuestion } from "./types";
import { Building2, TrendingUp } from "lucide-react";

interface BusinessProfileCompletionScreenProps {
  question: AssessmentQuestion;
  onFinish: () => void;
  scoreIncrease?: number;
}

export function BusinessProfileCompletionScreen({ 
  question, 
  onFinish, 
  scoreIncrease = 18 
}: BusinessProfileCompletionScreenProps) {
  const navigate = useNavigate();

  return (
    <div className="text-center space-y-8 py-8 w-full max-w-4xl mx-auto min-h-[400px] flex flex-col justify-center">
      <div className="flex justify-center mb-6">
        <div className="flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full">
          <Building2 className="w-8 h-8 text-primary" />
        </div>
      </div>
      
      <div className="space-y-4">
        <h2 className="text-2xl font-semibold text-foreground">
          Business Profile Complete!
        </h2>
        <p className="text-lg text-muted-foreground max-w-lg mx-auto">
          Excellent work completing your comprehensive business profile. This information is critical for accurate succession planning.
        </p>
        <div className="flex items-center justify-center gap-2 text-lg">
          <TrendingUp className="w-5 h-5 text-primary" />
          <span className="text-muted-foreground">
            Your mySuccession score has <span className="text-primary font-semibold">increased by {scoreIncrease}%</span>
          </span>
        </div>
        <p className="text-sm text-muted-foreground max-w-lg mx-auto">
          Your business profile now provides the foundation for personalized valuation insights and succession strategies.
        </p>
      </div>
      
      <div className="flex gap-4 justify-center">
        <Button 
          size="sm" 
          onClick={onFinish} 
          variant="outline"
          className="px-4 py-2 h-auto text-sm"
        >
          Close Profile
        </Button>
        <Button 
          size="sm" 
          onClick={() => navigate("/company")}
          className="bg-accent hover:bg-accent/90 text-accent-foreground px-4 py-2 h-auto text-sm"
        >
          View Company Dashboard
        </Button>
      </div>
    </div>
  );
}